export const REPORT_STATUSES = [
  { value: 'all', label: 'All snags' },
  { value: 'active', label: 'Open' },
  { value: 'ready_for_inspection', label: 'Ready to inspect' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'closed', label: 'Closed' },
  { value: 'attention', label: 'Action required (inspection or comments)' },
] as const;
export type ReportStatus = typeof REPORT_STATUSES[number]['value'];
type ReportRow = { projectId: string; status: string; contractorId: string | null; dueDate: string | null; recordState: string; commentAttention?: boolean };

export function reportStatus(value: string): ReportStatus {
  return REPORT_STATUSES.find(item => item.value === value)?.value ?? 'all';
}

/** Filters only the already-authorised project snapshot supplied by the caller. */
export function filterReportSnags<T extends ReportRow>(snags: readonly T[], projectId: string, status: ReportStatus, contractor: string, today: string, includeRetained = false): T[] {
  return snags.filter(snag => {
    if (snag.projectId !== projectId || !includeRetained && snag.recordState !== 'live') return false;
    if (contractor === 'unassigned' ? Boolean(snag.contractorId) : contractor !== 'all' && snag.contractorId !== contractor) return false;
    if (status === 'all') return true;
    if (status === 'active') return ['open', 'in_progress', 'returned'].includes(snag.status);
    if (status === 'overdue') return Boolean(snag.dueDate && snag.dueDate < today && snag.status !== 'closed');
    if (status === 'attention') return snag.status === 'ready_for_inspection' || Boolean(snag.commentAttention);
    return snag.status === status;
  });
}
